import { IPaneRenderer } from './ipane-renderer';

export class CompositeRenderer implements IPaneRenderer {
	private _renderers: ReadonlyArray<IPaneRenderer> = [];

	public setRenderers(renderers: ReadonlyArray<IPaneRenderer>): void {
		this._renderers = renderers;
	}

	public isSpecial(): boolean {
		return true;
	}

	public draw(ctx: CanvasRenderingContext2D, paneID: number, pixelRatio: number, isHovered: boolean, hitTestData?: unknown): void {
		this._renderers.forEach((r: IPaneRenderer) => {
			ctx.save();			
			r.draw(ctx,paneID, pixelRatio, isHovered, hitTestData);
			ctx.restore();
		});
	}
}
